export const LK_LINK = 'https://my.cian.ru/';
